import React from "react";

const MFAInfoDialog = (props: any) => {
    return (
        <React.Fragment>
            <div className="dialog-header">
                <h1>{props.dialogData.header}</h1>
            </div>
            <div className="dialog-body">
                <p>{props.dialogData.description1}</p>
                <p>{props.dialogData.description2}</p>
            </div>
        </React.Fragment>
    );
};

export default MFAInfoDialog;
